export class ModelBase {
  $type: string;
}



// WEBPACK FOOTER //
// ./src/app/pillar/common/models/ModelBase.ts